var LoadingButton = require("components/utility/LoadingButton");
var ErrorDisplay = require("components/utility/ErrorDisplay");
var Spinner = require("components/utility/Spinner");
var WhooosReadingServices = require("lib/web/WhooosReadingServices");
var GoogleClassroomSync = require("lib/integrations/GoogleClassroomSync");
var CurrentUser = require("lib/account/CurrentUser");
var SSORosterReview = require("components/org/roster_upload/SSORosterReview");
var PendingTaskNotice = require("components/layout/PendingTaskNotice");

require("org/roster/google_sync.scss");

class GoogleSync extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			loading: false, loadingDataStores: false,
			dependenciesLoaded: false, rosterData: null,
			teacherEmail: "", error: false, syncMessage: null
		};
	}

	handleAuthClick() {
		this.refs.errors.reset();
		this.setState({ loading: true, syncMessage: "Select your Google Account" });
		GoogleClassroomSync.beginSync(this.onSyncSuccess, this.onSyncMessageUpdate)
	}

	onSyncSuccess(success, teacherData, rosterData, errorMessage) {
		if (success) {
			this.setState({ loading: false, syncMessage: null, rosterData: rosterData });
			this.savePendingRoster(rosterData, teacherData.google_sso_id);
		} else {
			this.refs.errors.setError(errorMessage);
			this.setState({ loading: false })
		}
	}

	onSyncMessageUpdate(message) {
		this.setState({ syncMessage: message });
	}

	savePendingRoster(rosterData, teacherGoogleID) {
		var accessToken = CurrentUser.getToken();
		var uploadData = {
			access_token: accessToken,
			roster_data: JSON.stringify(rosterData),
			teacher_google_id: teacherGoogleID,
			store: true
		};

		this.submitRoster(uploadData);
	}

	submitRoster(uploadData, callback) {
		var syncURL = WhooosReadingServices.SsoServer.url("/google_classroom_sync");
		$.post(syncURL, uploadData);
	}

	finalizeRoster(updatedRosterData) {
		var accessToken = CurrentUser.getToken();

		var uploadData = {
			access_token: accessToken,
			roster_data: JSON.stringify(updatedRosterData),
			create: true
		};

		this.submitRoster(uploadData);

		var studentCount = 0;
		_.each(updatedRosterData, (section) => {
			studentCount += section.students.length;
		})
		this.props.onUpload(studentCount, false, PendingTaskNotice.GOOGLE_SYNC);
	}

	render() {
		if (this.state.loadingDataStores) {
			var section = (
				<Spinner placeholder scale={ 1.7 } />
			);
		} else {

			// ALLOW GOOGLE SYNC AT ALL TIMES
			if (this.state.dependenciesLoaded) {

				// DISPLAY DIFFERENT BTN MESSAGES BASED ON 3 STATES. NO SYNC, SYNCED WITH DATE, SYNCED BUT NO DATE
				if (this.state.lastUpdate) {
					var lastUpdate = new Date(this.state.lastUpdate)
					var btnText = `Refresh classes - last update: ${lastUpdate.toLocaleDateString()}`
				} else if (!this.state.rosterData == null) {
					var btnText = "Sync new classes"
				} else {
					var btnText = "Connect Google Classroom"
				}

				var button = (
					<LoadingButton text={btnText} className="btn buttonPrimary"
						loading={ this.state.loading } onClick={ this.handleAuthClick } />
				);
			} else {
				var button = (
					<Spinner placeholder={ true } />
				);
			}

			if (this.state.rosterData == null) {
				var syncMessage = this.state.syncMessage;
				if (this.state.loading && this.state.syncMessage) {
					var textDisplay = (
						<p className="loadingText">
							<em>Connecting your Google Classroom Account...</em>
						</p>
					);
				} else {
					var textDisplay = (
						<div>
							<p className="googleClassroomText">
								Connect your Google Classroom account to upload your classes and students.
							</p>
						</div>
					)
				}

				var section = (
					<div className="googleClassroomStepOne">
						{ textDisplay }
						{ button }
					</div>
				);
			} else {
				var section = (
					<div className="googleClassroomStepTwo">
						
						
						<SSORosterReview rosterData={ this.state.rosterData }
							finalizeRoster={ this.finalizeRoster }
							method={ SSORosterReview.GOOGLE_SYNC }
							studentCount={ this.props.studentCount } />

						{ button }
					</div>
				)
			}

		}

		// } else if (this.state.rosterData == null) {
		// 	if (this.state.dependenciesLoaded) {
		// 		var button = (
		// 			<LoadingButton text="Connect Google Classroom" className="btn buttonPrimary"
		// 				loading={ this.state.loading } onClick={ this.handleAuthClick } />
		// 		);
		// 	} else {
		// 		var button = (
		// 			<Spinner placeholder={ true } />
		// 		);
		// 	}
		// 	var syncMessage = this.state.syncMessage;
		// 	if (this.state.loading && this.state.syncMessage) {
		// 		var textDisplay = (
		// 			<p className="loadingText">
		// 				<em>Connecting your Google Classroom Account...</em>
		// 			</p>
		// 		);
		// 	} else {
		// 		var textDisplay = (
		// 			<div>
		// 				<p className="googleClassroomText">
		// 					Connect your Google Classroom account to upload your classes and students.
		// 				</p>
		// 			</div>
		// 		)
		// 	}

		// 	var section = (
		// 		<div className="googleClassroomStepOne">
		// 			{ textDisplay }
		// 			{ button }
		// 		</div>
		// 	);


		// } else {
		// 	var section = (
		// 		<div className="googleClassroomStepTwo">
		// 			<SSORosterReview rosterData={ this.state.rosterData } lastUpdate={this.state.lastUpdate}
		// 				finalizeRoster={ this.finalizeRoster }
		// 				method={ SSORosterReview.GOOGLE_SYNC }
		// 				studentCount={ this.props.studentCount } />
		// 		</div>
		// 	)
		// }

		return (
			<div className="googleClassroomView">
				<ErrorDisplay ref="errors" />
				{ section }
			</div>
		)
	}

	componentDidMount() {
		$wr.loadScript("https://apis.google.com/js/client.js", "gapi", function() {
			this.setState({ dependenciesLoaded: true });
		}.bind(this));

		this.setState({ loadingDataStores: true });
		var embeds = "user.pending_data_stores";

		var userID = CurrentUser.get().id;
		CurrentUser.api().getUser(userID, { embed: embeds }, $wr.apiHandler((response) => {
			var googleSyncStore = _.findWhere(response.user.pending_data_stores, {
				type: "google-sync"
			});

			if (googleSyncStore) {
				this.setState({ rosterData: googleSyncStore.data, lastUpdate: googleSyncStore.updated_at, loadingDataStores: false })
			} else {
				this.setState({ loadingDataStores: false })				
			}
		}));
	}
};

GoogleSync.propTypes = StrictPropTypes({
	onUpload: PropTypes.func.isRequired,
	currentStudentLists: PropTypes.array,
	studentCount: PropTypes.number
});

module.exports = GoogleSync;



// WEBPACK FOOTER //
// ./modules/components/org/roster_upload/GoogleSync.js